import React, { Component } from 'react';

import Blank from '../../../hoc/Blank/Blank';
import Button from '../../UI/Button/Button';

class AddOrderSuccessModal extends Component {
    render () {
        return (
            <Blank>
                <h3>Order Saved</h3>
                <p>Your order will not be approved until it has been
                <br />paid, turned in and verified.
                </p>                
                <Button btnType="Danger" clicked={this.props.addOrderSuccessmodalClosed}>CANCEL</Button>
            </Blank>
        );
    }
}

export default AddOrderSuccessModal;


// WEBPACK FOOTER //
// ./src/components/SuccessModals/AddOrderSuccessModal/AddOrderSuccessModal.js